import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import Profile from "../pages/UserProfile/Profile"

//Master
import User from "pages/Master/User/User"
import Adduser from "pages/Master/User/Adduser"
import Timeslote from "pages/Master/timeslote/Timeslote"
import Size from "pages/Master/size/Size"
import Inquiries from "pages/Master/inquries/Inquiries"
import Color from "pages/Master/color/Color"
import Categories from "pages/Master/Categories/Categories"
import Plan from "pages/Master/Plan/Plan"
import Reminder from "pages/Master/Reminder/Reminder"

import InvoiceDetail from "../pages/Invoices/invoices-detail"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/InternalServerError"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

// Products
import Products from "../pages/Master/Inventory/Products"
import CreateProduct from "pages/Master/Inventory/CreateProduct"
import UpdateProduct from "pages/Master/Inventory/UpdateProduct"

// Transactions
import Booking from "pages/Transiction/Booking"
import CreateBooking from "pages/Transiction/CreateBooking"
import CartListTable from "pages/Transiction/CartListTable"
import CreditNotes from "pages/Transiction/CreditNotes/CreditNotes"

// Reports
import RBooking from "pages/Reports/Booking/RBooking"
import Delivery from "pages/Reports/Delivery/Delivery"
import Return from "pages/Reports/Return/Return"

// setting
import Setting from "pages/Setting/Setting"
import Demo from "pages/Demo"
import Avaiblity from "pages/Avaiblity/Avaiblity"
import UpadateUser from "pages/Master/User/UpadateUser"

//invoice
import Invoice from "pages/Invoice/Invoice"
// Subscriptions
import Subscriptions from "pages/Subcription/Subscription"

import { routes } from "./path"
import ViewBooking from "pages/Transiction/BookingView"
import ImportProduct from "pages/ImportProduct/ImportProduct"
import ProductHistory from "pages/Reports/ProductHistory/ProductHistory"
import Salesman from "pages/Reports/Salesman/Salesman"
import AllPlans from "pages/AllPlans"
import Holdbills from "pages/Transiction/Holdbills"
import Income from "pages/Transiction/Income/Income"
import Expenses from "pages/Transiction/Expenses/Expenses"
import IncomExpense from "pages/Reports/Inccome-Expense/IncomExpense"
import Decrypt from "pages/Master/Decryption/Decrypt"
import DecrptData from "pages/DecryptData/DecrptData"
import SalesList from "pages/Transiction/Sales/SalesList"
import CreateSales from "pages/Transiction/Sales/CreateSales"
import ProductCatalogue from "pages/Master/Inventory/ProductCatalogue/ProductCatalogue"
import Tutorial from "pages/Tutorial/Tutorial"
import TutorialForVendor from "pages/Tutorial/TutorialListForVendor"
import ReleseNote from "pages/relesenote/ReleseNote"
import IncomeExpenseReport from "pages/Reports/Finance/IncomeExpenceReport"
import PendingBills from "pages/Reports/Pending-Bills/PendingBillsReport"
import SubCategories from "pages/Reports/SubCategories/SubCategories"
import DepositReport from "pages/Reports/Deposit/DepositReport"
import InquiriesList from "pages/Reports/Inquiries/InquiriesList"
import Accounts from "pages/Master/Accounts/Accounts"
import Items from "pages/Master/Items/Items"
import JournalVouchers from "pages/Transiction/JournalVouchers/JournalVouchers"
import PurchaseList from "pages/Transiction/Purchases/PurchaseList"
import CreatePurchase from "pages/Transiction/Purchases/CreatePurchase"
import CreateCreditNote from "pages/Transiction/CreditNotes/CreateCreditNote"
import BookedOrders from "pages/Reports/BookedOrders/BookedOrders"
import WashingProducts from "pages/Master/Inventory/Washing/WashingList"
import DBBackup from "pages/DBBackup/DBBackup"
import FeedbacksReport from "pages/Reports/FeedBacks/FeedBacksReport"
import FeedbackQuestion from "pages/Master/FeedBackQuestion/FeedBackQuestion"
import Feedback from "pages/Transiction/Feedback/Feedback"
import ManufactureProductList from "pages/Master/Inventory/ManufactureProduct/ManufactureProductList"
import CreateUpdateManufactureProduct from "pages/Master/Inventory/ManufactureProduct/CreateUpdateManufactureProduct"
import BookingOutstandingReport from "pages/Reports/BookingOutstanding/BookingOutstandingReport"

const authProtectedRoutes = [
  { path: routes.dashboard, component: <Dashboard /> },

  // Tutorials
  { path: routes.tutorial, component: <Tutorial /> },
  { path: routes.tutorialForVendor, component: <TutorialForVendor /> },

  // Master
  { path: routes.userList, component: <User /> },
  { path: routes.userCreate, component: <Adduser /> },
  { path: routes.userUpdate, component: <UpadateUser /> },
  { path: routes.inquiries, component: <Inquiries /> },
  { path: routes.categories, component: <Categories /> },
  { path: routes.size, component: <Size /> },
  { path: routes.color, component: <Color /> },
  { path: routes.timeslot, component: <Timeslote /> },
  { path: routes.plan, component: <Plan /> },
  { path: routes.reminder, component: <Reminder /> },
  { path: routes.accounts, component: <Accounts /> },
  { path: routes.feedbackQuestion, component: <FeedbackQuestion /> },
  { path: routes.items, component: <Items /> },
  { path: routes.available, component: <Avaiblity /> },
  { path: routes.demo, component: <Demo /> },

  // Product
  { path: routes.productList, component: <Products /> },
  { path: routes.createProduct, component: <CreateProduct /> },
  { path: routes.updateproduct, component: <UpdateProduct /> },
  { path: routes.importProduct, component: <ImportProduct /> },
  { path: routes.catalogue, component: <ProductCatalogue /> },
  { path: routes.productHistory, component: <ProductHistory /> },
  { path: routes.Washing, component: <WashingProducts /> },
  { path: routes.manufactureProduct, component: <ManufactureProductList /> },
  { path: routes.createmanufactureProduct, component: <CreateUpdateManufactureProduct /> },
  { path: routes.updatemanufactureProduct, component: <CreateUpdateManufactureProduct /> },

  // Transaction
  { path: routes.bookingList, component: <Booking /> },
  { path: routes.HoldBillList, component: <Holdbills /> },
  { path: routes.createbooking, component: <CreateBooking /> },
  { path: routes.updatebooking, component: <CreateBooking /> },
  { path: routes.viewBooking, component: <InvoiceDetail /> },
  { path: routes.CreditNote, component: <CreditNotes /> },
  { path: routes.CreateCreditNote, component: <CreateCreditNote /> },
  { path: routes.cartlist, component: <CartListTable /> },
  { path: routes.income, component: <Income /> },
  { path: routes.expenses, component: <Expenses /> },
  { path: routes.createSale, component: <CreateSales /> },
  { path: routes.updateSale, component: <CreateSales /> },
  { path: routes.salesList, component: <SalesList /> },
  { path: routes.purchaseList, component: <PurchaseList /> },
  { path: routes.createPurchase, component: <CreatePurchase /> },
  { path: routes.UpdatePurchase, component: <CreatePurchase /> },
  { path: routes.journalVouchers, component: <JournalVouchers /> },
  { path: routes.feedback, component: <Feedback /> },

  // Reports
  { path: routes.reportBooking, component: <RBooking /> },
  { path: routes.delivery, component: <Delivery /> },
  { path: routes.return, component: <Return /> },
  { path: routes.subCategories, component: <SubCategories /> },
  { path: routes.pendingBills, component: <PendingBills /> },
  { path: routes.finance, component: <IncomeExpenseReport /> },
  { path: routes.salesman, component: <Salesman /> },
  { path: routes.bookedOrdersReport, component: <BookedOrders /> },
  { path: routes.incomeExpense, component: <IncomExpense /> },
  { path: routes.deposit, component: <DepositReport /> },
  { path: routes.InquiryData, component: <InquiriesList /> },
  { path: routes.feedbackReport, component: <FeedbacksReport /> },
  { path: routes.bookingOutstanding, component: <BookingOutstandingReport /> },

  // Settings
  { path: routes.setting, component: <Setting /> },

  // db-backup
  { path: routes.dbBackup, component: <DBBackup /> },

  { path: routes.invoice, component: <Invoice /> },
  // Subscriptions
  { path: routes.subscription, component: <Subscriptions /> },

  // Decryption
  { path: routes.decrypt, component: <Decrypt /> },

  // Profile
  { path: routes.profile, component: <Profile /> },

  // Relese Note
  { path: routes.releseNote, component: <ReleseNote /> },


  //profile
  // { path: "/profile", component: <UserProfile /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // { path: "/inquiry", component: <Register /> },
  { path: "/plans", component: <AllPlans /> },
  { path: "/decryptData", component: <DecrptData /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  { path: "/submission-inquiry", component: <Pages500 /> },
]

export { authProtectedRoutes, publicRoutes }
